var _defs, _rect, _rect2, _rect3, _rect4, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100,
    zoomAndPan: "magnify",
    viewBox: "0 0 75 74.999997",
    height: 100,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("g", null))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -7.5,
    width: 90,
    fill: "rgb(100%, 100%, 100%)",
    y: -7.5,
    height: 89.999996,
    fillOpacity: 1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -7.5,
    width: 90,
    fill: "rgb(4.309082%, 5.879211%, 12.159729%)",
    y: -7.5,
    height: 89.999996,
    fillOpacity: 1
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: -7.5,
    width: 90,
    fill: "rgb(100%, 100%, 100%)",
    y: -7.5,
    height: 89.999996,
    fillOpacity: 1
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: -7.5,
    width: 90,
    fill: "rgb(4.309082%, 5.879211%, 12.159729%)",
    y: -7.5,
    height: 89.999996,
    fillOpacity: 1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(81.17981%, 42.349243%, 18.429565%)",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(23.519665, 62.265439)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 1.828125 -30.671875 L 1.828125 -42.375 L 16.625 -51.953125 L 22.234375 -51.953125 L 22.234375 0 L 10.390625 0 L 10.390625 -36.203125 Z M 1.828125 -30.671875 "
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.0000c3682dc13e3f042a42aa9af22fbe.svg";
export { ForwardRef as ReactComponent };